module.exports = "https://static.wanderu.com/static/media/powered_by_google_on_white.581bd767.png";